/* eslint-disable */
import React from "react";

// Object.assign Polyfill.
const _extends =
  Object.assign ||
  function (target) {
    for (let i = 1; i < arguments.length; i++) {
      const source = arguments[i];
      for (const key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };

const Blur = function ({ children, radius = 0, transition = "0s" }) {
  const styles = {
    transition: `filter ${transition}`,
    WebkitFilter: `blur(${radius})`,
    filter: `blur(${radius})`,
  };

  return React.Children.count(children) > 1 ? React.createElement("span", { style: styles }, children) : addStylesToElement(React.Children.only(children), styles);
};

const addStylesToElement = function (el, styles) {
  return React.cloneElement(el, { style: { ...el.style, ...styles } });
};

export default Blur;
